import styled from 'styled-components';

export const CollapsableStyledClassFilter = styled.div`
  display: flex;
  padding-top: 10px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0 10px 10px;
  }
`;

export const StarButtonContainer = styled.div`
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.palette.iron};

  background: ${({ theme }) => theme.palette.lynxWhite};
  width: 58px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.palette.black};

  margin-right: 10px;
  color: ${({ theme }) => theme.palette.darkGrey};

  border: 1px solid ${({ theme }) => theme.palette.NL80};
  background: ${({ theme }) => theme.palette.NL30};
  border-radius: 4px;

  &.selected {
    border: 1px solid ${({ theme }) => theme.palette.persianRed};
  }
`;

export const ClassFilterTitle = styled.h3`
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.eclipse};
`;
